export default "__VITE_ASSET__b1230ad4__"